<template>
  <div>
    <v-container fluid class="px-0">
      <!-- <v-row dense class="mt-3 px-6">
        <v-col class="d-flex align-center">
          <h1 class="title">Integration Logs</h1>
        </v-col>
      </v-row> -->

      <v-row dense class="px-6 ">
        <v-col cols="12" md="2">
          <DatePickerTextBox v-model="dateRange" label="Created Between" @change="fetchLogs">
          </DatePickerTextBox>
        </v-col>
        <v-col cols="12" md="2">
          <v-select v-model="objectTypeFilter" :items="objectTypes" multiple label="Object Type" clearable dense outlined
            @change="fetchLogs" />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field v-model="referenceFilter" label="Reference" clearable dense outlined @change="fetchLogs" />
        </v-col>
        <v-col cols="12" md="2">
          <v-switch v-model="issuesOnly" @change="fetchLogs" label="Issues Only" />
        </v-col>
        <v-col cols="12" md="4" class="d-flex align-top justify-end">
          <v-btn color="primary" @click="fetchLogs" :loading="isLoading">
            <v-icon left>mdi-refresh</v-icon>
            Refresh
          </v-btn>
          <v-btn color="warning" class="ml-2" v-if="canAdmin" @click="manualPush.show = true" :loading="isLoading">
            <v-icon left>mdi-upload</v-icon>
            Manual Push
          </v-btn>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12">
          <v-data-table :headers="logHeaders"
            :items="integrationLogs"
            :loading="isLoading || docsListLoading"
            dense hide-default-footer
            class="mx-6 elevation-1"
            :items-per-page="itemsPerPage"
            :page.sync="currentPage"
            @click:row="openDetails">
            <template v-slot:[`item.object_title`]="{ item }">
              {{ getObjectTitle(item) }}
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <v-chip small :color="getStatusColor(item.status)" text-color="white">
                {{ item.status }} ({{ item.row_count }})
              </v-chip>
              <v-tooltip v-if="item.warnings_count > 0" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="warning" class="ml-1" v-bind="attrs" v-on="on">mdi-alert-circle</v-icon>
                </template>
                <span>{{ item.warnings_count }} warning(s) encountered. Click to View</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.last_update_at`]="{ item }">
              {{ formatDate(item.last_update_at) }}
            </template>

            <template v-slot:[`item.reference`]="{ item }">
              <v-icon small left>{{ getObjectTypeIcon(item.object_type) }}</v-icon>
              {{ item.reference }}
            </template>

            <template
              v-slot:footer
            >
              <div class="footer-actions primary-background">
                <PageDescription
                  :totalItems="integrationLogs.length"
                  :pageSize="itemsPerPage"
                  :currentPage="currentPage"
                />
                <Pagination
                  :totalItems="integrationLogs.length"
                  :pageSize="itemsPerPage"
                  :currentPage="currentPage"
                  @pageNavigation="currentPage = $event"
                />
                <div>
                  <v-btn color="primary"
                    outlined small
                    class="mr-2"
                    @click="exportToCSV">Export</v-btn>
                  <v-menu offset-y top z-index="301">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        outlined
                        small
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ itemsPerPageText }}
                        <v-icon right>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>

                    <v-list dense>
                      <v-list-item
                        v-for="item in itemsPerPageOptions"
                        :key="item.value"
                        @click="itemsPerPage = item.value"
                      >
                        <v-list-item-title>
                          {{ item.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </template>
          </v-data-table>
          
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="showDetails">
      <v-card>
        <v-card-title>
          <v-icon small left>{{ getObjectTypeIcon(selectedItem?.object_type) }}</v-icon>
          <a v-if="selectedItem?.object_type === 'profile'" href="#" @click.prevent="openDocument(selectedItem)">
            {{ selectedItem?.reference }}
          </a>
          <span v-else>
            {{ selectedItem?.reference }}
          </span>
          &nbsp;({{ getObjectTitle(selectedItem) }})
          <v-spacer></v-spacer>
          <v-btn icon large class="btn-background mr-2" @click="loadDetails" :loading="detailsLoading">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-btn icon large class="btn-background" @click="showDetails = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="detailHeaders" :items="itemDetails" :loading="detailsLoading" dense class="mx-3"
            :items-per-page="25" :footer-props="{
              'items-per-page-options': [10, 25, 50, 100]
            }">
            <template v-slot:[`item.status`]="{ item }">
              <v-chip small :color="getStatusColor(item.status)" text-color="white">
                {{ item.status }}
              </v-chip>
            </template>

            <template v-slot:[`item.warnings`]="{ item }">
              <span v-for="(warn, warni) in item.warnings?.split('\n')" :key="`warn${warni}`">
                {{ warn }}<br />
              </span>
            </template>

            <template v-slot:[`item.created_at`]="{ item }">
              {{ formatDate(item.created_at) }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          
          <v-spacer></v-spacer>

          <v-btn outlined color="warning" v-if="canAdmin" @click="resend">Resend</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="manualPush.show" width="800">
      <v-card>
        <v-card-title>
          Manual Push
          <v-spacer></v-spacer>
          <v-btn icon large class="btn-background" @click="manualPush.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-select
            v-model="manualPush.objectType"
            :items="objectTypes"
            label="Object Type"
            dense
            outlined
          />
          <v-textarea
            v-model="manualPush.objectIds"
            label="Object IDs (separated by comma or new line)"
            rows="4"
            dense
            outlined>
          </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="pushSelectedIds">Push Selected</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ResponseHandler :serviceResponse="response"></ResponseHandler>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';
import utils from "@/common/utils.js";
import ResponseHandler from "@/components/ResponseHandler";
import Pagination from "@/components/cPagination";
import DatePickerTextBox from "@/components/common/DatePickerTextBox.vue";
import PageDescription from "@/components/cPageDescription";
import { mapState } from "vuex";

export default {
  name: "cIntegrationLogs",
  components: {
    ResponseHandler,
    DatePickerTextBox,
    Pagination,
    PageDescription,
  },
  props: {
    qaActions: { type: Array, required: true },
  },
  data: function () {
    return {
      isLoading: false,
      response: null,
      integrationLogs: [],
      objectTypeFilter: [],
      referenceFilter: null,
      issuesOnly: false,
      dateRange: [
        moment().add(-1, 'days').format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD")
      ],
      objectTypes: [ 'profile', 'family-group', 'family', 'skill'],
      logHeaders: [
        { text: "Reference", value: "reference" },
        { text: "Object Type", value: "object_type" },
        { text: "Action", value: "actions" },
        { text: "Title", value: "object_title" },
        { text: "Status", value: "status" },
        { text: "Updated At", value: "last_update_at" },
        { text: "Requested By", value: "last_update_by" },
      ],
      detailHeaders: [
        { text: "Log ID", value: "log_id" },
        { text: "Requested At", value: "created_at" },
        { text: "Requested By", value: "created_by" },
        { text: "Layer", value: "layer" },
        { text: "Action", value: "action" },
        { text: "Status", value: "status" },
        { text: "Warnings", value: "warnings" },
        { text: "Error", value: "error" },
      ],
      currentPage: 1,
      itemsPerPage: 20,
      itemsPerPageOptions: [
        { text: "10 Rows", value: 10 },
        { text: "20 Rows", value: 20 },
        { text: "30 Rows", value: 30 },
        { text: "50 Rows", value: 50 },
      ],
      manualPush: {
        show: false,
        objectType: 'profile',
        objectIds: '',
      },
      showDetails: false,
      selectedItem: null,
      itemDetails: [],
      detailsLoading: false,
      docsList: [],
    };
  },
  computed: {
    ...mapState({
      docsListLoading: (state) => state.docs.loading,
      hierarchyNodeLookup: (state) => state.hierarchies.hierarchyNodeLookup,
      tagTypes: (state) => state.hierarchies.tagTypes,
      config: (state) => state.settings.config,
    }),
    tagValues() {
      const values = {};
      this.tagTypes.forEach(tt => {
        tt.values.forEach(tv => {
          values[`tv${tv.tag_value_id}`] = tv;
        });
      });
      return values;
    },
    canAdmin() {
      return this.qaActions.some(action => action.name === 'admin');
    },
    itemsPerPageText() {
      const option = this.itemsPerPageOptions.find(
        (o) => o.value == this.itemsPerPage
      );
      return option ? option.text : `${this.itemsPerPage} Items`;
    },
  },
  created() {
    this.fetchLogs();
  },
  methods: {
    fetchLogs() {
      this.isLoading = true;
      let possibleError = false;
      let fromDate = moment(this.dateRange[0]);
      let toDate = this.dateRange.length > 1 ? moment(this.dateRange[1]) : fromDate;

      const requestBody = {
        from_date: (fromDate.isBefore(toDate) ? fromDate : toDate).startOf('day').toISOString(),
        to_date: (fromDate.isBefore(toDate) ? toDate : fromDate).endOf('day').toISOString(),
        object_types: this.objectTypeFilter,
        reference: this.referenceFilter,
        issues_only: this.issuesOnly,
      };

      axios
        .post("report/integrationLogSummary", requestBody)
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            this.integrationLogs = resp.data.Data || [];
          }
          this.loadDocSummary();
          this.response = resp.data;
          this.isLoading = false;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
          this.isLoading = false;
        });
    },
    async loadDocSummary() {
      const docRefs = this.integrationLogs
        .filter(l => l.object_type === 'profile')
        .map(l => l.reference);

      if (!docRefs.length) return;

      const filterResult = await this.$store.getters["docs/pagedFilter"]({
        systemNumbersIncluded: docRefs,
        pageSize: docRefs.length
      });

      this.docsList = filterResult.documents;
    },
    openDetails(item) {
      this.selectedItem = item;
      this.itemDetails = [];
      this.showDetails = true;
      this.loadDetails();
    },
    loadDetails() {
      if (!this.selectedItem) return;
      this.detailsLoading = true;
      let possibleError = false;
      let fromDate = moment(this.dateRange[0]);
      let toDate = this.dateRange.length > 1 ? moment(this.dateRange[1]) : fromDate;
      const requestBody = {
        from_date: (fromDate.isBefore(toDate) ? fromDate : toDate).startOf('day').toISOString(),
        to_date: (fromDate.isBefore(toDate) ? toDate : fromDate).endOf('day').toISOString(),
        reference: this.selectedItem.reference,
      };

      axios
        .post("report/integrationLogDetails", requestBody)
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            this.itemDetails = resp.data.Data || [];
          }
          this.response = resp.data;
          this.detailsLoading = false;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);

          this.detailsLoading = false;
        });
    },
    resend() {
      if (!this.selectedItem) return;
      if (!confirm(`Are you sure you want to resend integration message for ${this.selectedItem.reference}?`)) {
        return;
      }

      this.detailsLoading = true;
      let possibleError = false;

      axios
        .post("message/sendIntegrationNotification", {
          objectType: this.selectedItem.object_type,
          objectIds: [ this.selectedItem.reference ],
        })
        .then((resp) => {
          possibleError = true;
          this.response = resp.data;
          if (resp.data.Status === "OK") {
            setTimeout(() => {
              this.loadDetails();
            }, 2000);
          }
          this.detailsLoading = false;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
          this.detailsLoading = false;
        });
    },
    pushSelectedIds() {
      this.isLoading = true;
      let possibleError = false;

      axios
        .post("message/sendIntegrationNotification", {
          objectType: this.manualPush.objectType,
          objectIds: this.manualPush.objectIds
            .split(/[\n,]+/)
            .map(id => id.trim())
            .filter(id => id),
        })
        .then((resp) => {
          possibleError = true;
          this.response = resp.data;
          if (resp.data.Status === "OK") {
            setTimeout(() => {
              this.fetchLogs();
            }, 3000);
          }
          this.isLoading = false;
          this.manualPush.show = false;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
          this.isLoading = false;
        });

    },
    openDocument(item) {
      if (!item) return;
      const doc = this.docsList?.find((d) => d.system_number === item.reference);
      if (!doc) return;

      this.$emit("openDocument", doc);
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleString();
    },
    getStatusColor(status) {
      const statusLower = (status || "").toLowerCase();
      switch (statusLower) {
        case "success":
        case "completed":
        case "ok":
          return "success";
        case "error":
        case "failed":
          return "error";
        case "pending":
        case "processing":
          return "info";
        case "retry":
        case "warn":
          return "warning";
        default:
          return "grey";
      }
    },
    getObjectTypeIcon(objectType) {
      const typeLower = (objectType || "").toLowerCase();
      if (typeLower.includes("job") || typeLower.includes("profile")) {
        return "mdi-briefcase";
      } else if (typeLower.includes("group")) {
        return "mdi-family-tree";
      } else if (typeLower.includes("family")) {
        return "mdi-account-group";
      } else if (typeLower.includes("user") || typeLower.includes("person")) {
        return "mdi-account";
      } else if (typeLower.includes("organization") || typeLower.includes("org")) {
        return "mdi-domain";
      } else if (typeLower.includes("document") || typeLower.includes("doc")) {
        return "mdi-file-document";
      } else if (typeLower.includes("skill") || typeLower.includes("tag")) {
        return "mdi-tag";
      } else {
        return "mdi-file";
      }
    },
    getObjectTitle(item) {
      if (!item) return '-';
      if (item.object_type === 'profile')
        return this.docsList?.find((d) => d.system_number === item.reference)?.doc_name || '-';
      else if (item.object_type.startsWith('family'))
        return this.hierarchyNodeLookup[`hn${item.reference.replace(/[^0-9]/g, '')}`]?.name || '-';
      else if (item.object_type.startsWith('skill') || item.object_type.startsWith('tag'))
        return this.tagValues[`tv${item.reference.replace(/[^0-9]/g, '')}`]?.value || '-';

      return '-';
    },
    exportToCSV() {
      let data = this.logHeaders.map((h) => utils.csvEscape(h.text)).join(",");
      data += "\n";

      this.integrationLogs.forEach((l) => {
        data += this.logHeaders
          .map((h) => {
            if (h.value === 'object_title')
              return utils.csvEscape(this.getObjectTitle(l))
            else
              return utils.csvEscape(l[h.value]);
          })
          .join(",");
        data += "\n";
      });

      utils.downloadFile(
        data,
        `${this.$loginState.user.client.replace(
          new RegExp("\\s+", "g"),
          "_"
        )}_integration_logs_${moment().format("YYYYMMDDhhmmss")}.csv`,
        "text/csv;encoding:utf-8"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  height: 55px;

  div {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
  }
}
::v-deep .v-data-table {

  tbody>tr,
  tbody>tr span {
    cursor: pointer;
  }
}
</style>
